import { ADMIN_PATHS } from "../constants/adminWorkspace";

export const ADMIN_OVERVIEW_SHORTCUTS = [
  {
    id: "users",
    title: "Users",
    body: "Find accounts, see who is admin, and elevate access.",
    path: ADMIN_PATHS.users,
  },
  {
    id: "ops",
    title: "Ops",
    body: "Check whether sport rails ran and what they wrote.",
    path: ADMIN_PATHS.ops,
  },
  {
    id: "trivia",
    title: "Trivia",
    body: "Tune the engine, review artifacts, and manage the bank.",
    path: ADMIN_PATHS.trivia,
  },
];

export const formatAdminCount = (value) => {
  if (value == null) return "—";
  return Number(value).toLocaleString();
};

export const summarizeOpsRuns = (runs = []) => {
  const failed = runs.filter((run) => run.status === "failed").length;
  const partial = runs.filter((run) => run.status === "partial").length;
  const ok = runs.filter((run) => run.status === "ok").length;
  return { failed, partial, ok, total: runs.length };
};
